module.exports = __webpack_public_path__ + "static/decisive-70e9434c2406e767642e006faf5ba525.jpg";